import React from 'react';
import './SimilarContactsPanel.css';

const LABEL = {
  industry: {
    _title: 'Branche',
    'SaaS': 'SaaS', 'E-Commerce': 'E-Commerce', 'Agency': 'Agentur', 'Consulting': 'Beratung',
    'Real Estate': 'Immobilien', 'Finance': 'Finanzen', 'Healthcare': 'Gesundheit',
    'Education': 'Bildung', 'Manufacturing': 'Produktion', 'Retail': 'Handel',
    'Food & Beverage': 'Gastronomie', 'Fitness & Wellness': 'Fitness & Wellness',
    'Legal': 'Recht', 'Media & Entertainment': 'Medien', 'Construction': 'Bau & Architektur',
    'Automotive': 'Automotive', 'Travel & Tourism': 'Reisen', 'Logistics': 'Logistik',
    'Insurance': 'Versicherung', 'Non-Profit': 'Non-Profit', 'Recruiting': 'Recruiting',
    'Beauty & Cosmetics': 'Beauty', 'Photography': 'Fotografie', 'Architecture': 'Architektur',
    'IT Services': 'IT Services', 'Marketing': 'Marketing', 'Design': 'Design',
    'Coaching': 'Coaching', 'Events': 'Events', 'Other': 'Sonstige',
  },
  offerType: {
    _title: 'Angebot',
    service: 'Dienstleistung', saas: 'Software/SaaS', physical_product: 'Produkt',
    education: 'Bildung/Kurse', marketplace: 'Marktplatz', media_content: 'Medien & Content',
    financial_service: 'Finanzdienstleistung', healthcare_service: 'Gesundheitsdienst',
    legal_service: 'Rechtsdienstleistung', coaching: 'Coaching', agency_service: 'Agenturleistung',
    recruiting: 'Recruiting', other: 'Sonstige',
  },
  sizeProxy: {
    _title: 'Größe',
    SOLO: 'Einzelperson', SMALL: 'Kleines Team', MID: 'Mittelgroß', ENT: 'Unternehmen',
  },
  b2b_b2c: {
    _title: 'Zielgruppe',
    b2b: 'Geschäftskunden', b2c: 'Endkunden', both: 'Beide',
  },
};

function readable(category, value) {
  if (!value || value === 'unknown') return null;
  return LABEL[category]?.[value] || value;
}

function getMatchReasons(result) {
  const reasons = [];
  const bd = result.breakdown;
  const sig = result.contact.leadSignals || {};

  if (bd.industry) reasons.push(`Gleiche Branche: ${readable('industry', sig.industry)}`);
  if (bd.offerType) reasons.push(`Gleiches Angebot: ${readable('offerType', sig.offerType)}`);
  if (bd.sizeProxy) reasons.push(`Gleiche Größe: ${readable('sizeProxy', sig.sizeProxy)}`);
  if (bd.b2b_b2c) reasons.push(`Gleiche Zielgruppe: ${readable('b2b_b2c', sig.b2b_b2c)}`);
  if (result.matchedTags?.length > 0) {
    reasons.push(`${result.matchedTags.length} gemeinsame Tags`);
  }
  return reasons;
}

function scoreLabel(score) {
  if (score >= 70) return 'Sehr ähnlich';
  if (score >= 50) return 'Ähnlich';
  if (score >= 30) return 'Teilweise ähnlich';
  return 'Schwache Übereinstimmung';
}

const SimilarContactsPanel = ({ show, target, results, onClose, onContactClick, loading }) => {
  if (!show) return null;

  const signals = target?.leadSignals || {};
  const targetName = target?.business_name || target?.name || target?.lead_email?.split('@')[0] || 'Kontakt';

  return (
    <div className="similar-panel-overlay" onClick={onClose}>
      <div className="similar-panel" onClick={e => e.stopPropagation()}>

        <div className="similar-panel-header">
          <div>
            <h3>Ähnliche Kontakte</h3>
            <p className="similar-panel-subtitle">
              Kontakte mit ähnlichem Profil wie <strong>{targetName}</strong>
            </p>
          </div>
          <button className="similar-panel-close" onClick={onClose}>&times;</button>
        </div>

        <div className="similar-panel-target-profile">
          <span className="similar-profile-label">Profil:</span>
          {readable('industry', signals.industry) && (
            <span className="signal-chip industry">{readable('industry', signals.industry)}</span>
          )}
          {readable('offerType', signals.offerType) && (
            <span className="signal-chip offer">{readable('offerType', signals.offerType)}</span>
          )}
          {readable('sizeProxy', signals.sizeProxy) && (
            <span className="signal-chip size">{readable('sizeProxy', signals.sizeProxy)}</span>
          )}
          {readable('b2b_b2c', signals.b2b_b2c) && (
            <span className="signal-chip b2b">{readable('b2b_b2c', signals.b2b_b2c)}</span>
          )}
        </div>

        <div className="similar-panel-results">
          {loading ? (
            <div className="similar-panel-loading">
              <div className="spinner-small" />
              <span>Suche ähnliche Kontakte…</span>
            </div>
          ) : results.length === 0 ? (
            <div className="similar-panel-empty">
              <p>Keine ähnlichen Kontakte gefunden.</p>
              <p className="similar-panel-empty-hint">
                Kontakte brauchen klassifizierte Signale für den Vergleich.
              </p>
            </div>
          ) : (
            results.map((result, i) => {
              const c = result.contact;
              const sig = c.leadSignals || {};
              const reasons = getMatchReasons(result);
              const label = scoreLabel(result.score);
              const displayName = c.business_name || c.name || c.lead_email || 'Unbekannt';

              return (
                <div
                  key={c.id}
                  className={`similar-result-card ${result.score >= 60 ? 'high-match' : ''}`}
                  onClick={() => onContactClick(c)}
                >
                  <div className="similar-result-top">
                    <div className="similar-result-info">
                      <span className="similar-result-rank">#{i + 1}</span>
                      <div style={{ minWidth: 0 }}>
                        <div className="similar-result-name">{displayName}</div>
                        {c.lead_email && <div className="similar-result-email">{c.lead_email}</div>}
                      </div>
                    </div>
                    <div className="similar-result-score">
                      <span className="score-pct">{result.score}%</span>
                      <span className="score-label">{label}</span>
                    </div>
                  </div>

                  <div className="similar-result-bar">
                    <div
                      className="similar-result-bar-fill"
                      style={{
                        width: `${result.score}%`,
                        background: result.score >= 60
                          ? 'linear-gradient(90deg, #22c55e, #16a34a)'
                          : result.score >= 35
                          ? 'linear-gradient(90deg, #eab308, #f59e0b)'
                          : '#cbd5e1',
                      }}
                    />
                  </div>

                  {reasons.length > 0 && (
                    <div className="similar-result-reasons">
                      {reasons.map((r, j) => (
                        <span key={j} className="reason-chip">{r}</span>
                      ))}
                    </div>
                  )}

                  <div className="similar-result-tags">
                    {readable('industry', sig.industry) && (
                      <span className={`match-chip ${result.breakdown.industry ? 'matched' : ''}`}>
                        {readable('industry', sig.industry)}
                      </span>
                    )}
                    {readable('offerType', sig.offerType) && (
                      <span className={`match-chip ${result.breakdown.offerType ? 'matched' : ''}`}>
                        {readable('offerType', sig.offerType)}
                      </span>
                    )}
                    {readable('sizeProxy', sig.sizeProxy) && (
                      <span className={`match-chip ${result.breakdown.sizeProxy ? 'matched' : ''}`}>
                        {readable('sizeProxy', sig.sizeProxy)}
                      </span>
                    )}
                  </div>
                </div>
              );
            })
          )}
        </div>

        {results.length > 0 && (
          <div className="similar-panel-footer">
            <span>{results.length} ähnliche Kontakte gefunden</span>
            <span className="similar-panel-hint">Klicke einen Kontakt um in der Tabelle hinzuspringen</span>
          </div>
        )}
      </div>
    </div>
  );
};

export default SimilarContactsPanel;
